import { FormsV1 } from '@frontend/api-digital-forms';
import { DEFAULT_DFX_HTTP_OPTIONS } from '../../constants';

export const useGetInsurancePayers = (locationId: string) => {
  const { data, isLoading, isError } = FormsV1.Queries.useGetInsurancePayersQuery({
    request: { companyId: locationId },
    options: {
      enabled: !!locationId,
      staleTime: Infinity,
      cacheTime: Infinity,
    },
    httpOptions: DEFAULT_DFX_HTTP_OPTIONS,
  });

  const payers = data?.insurancePayers ?? [];

  return { payers, isLoading, isError };
};
